import {setupModal, openModal, setModalListeners} from '../utils/modal';

const siteSearch = () => {

  const searchButton = document.querySelector('.header__search');

  if (!searchButton) {
    return;
  }

  const searchModal = document.querySelector('.modal-search');

  searchButton.addEventListener('click', function () {
    openModal(searchModal);
  });

  setModalListeners(searchModal);
  setupModal(searchModal);


};

export {siteSearch};
